import { Share2 } from "lucide-react";
import { useState } from "react";
import { ShareDialog } from "@/components/sharing/ShareDialog";
import { Button } from "@/components/ui/button";
import type { Album, ProjectDetail } from "@/schemas/photos";
import type { ShareSummary } from "@/schemas/shares";

/** Under an album card, for a PM: who sees how much of it, and the one action to share it. */
export function AlbumShareFooter({
  project,
  album,
  summary,
}: {
  project: ProjectDetail;
  album: Album;
  summary: ShareSummary | undefined;
}) {
  const [open, setOpen] = useState(false);
  const shared = summary?.albums.filter((row) => row.albumId === album.id) ?? [];

  return (
    <div className="mt-auto flex flex-col gap-2 border-t px-3 py-2">
      <div data-testid="album-share-state" className="text-xs text-muted-foreground">
        {shared.length === 0
          ? "Not shared"
          : shared.map((row) => (
              <span key={row.audience} className="block tabular-nums">
                {row.sharedCount.toLocaleString("en-US")} of{" "}
                {album.photoCount.toLocaleString("en-US")} shared with {row.audience}
              </span>
            ))}
      </div>
      <Button
        variant="outline"
        size="sm"
        data-testid="album-share"
        aria-label={`Share ${album.name}`}
        disabled={!summary}
        onClick={() => setOpen(true)}
        className="w-full"
      >
        <Share2 className="size-3.5" />
        Share
      </Button>
      {open && summary && (
        <ShareDialog
          open
          onOpenChange={setOpen}
          project={project}
          album={album}
          audiences={summary.audiences}
        />
      )}
    </div>
  );
}
